export class Captcha {
  constructor() {
    this.initCaptcha('zh');
    this.success = () => {};
  }

  initCaptcha(language) {
    try {
      const el = document.createElement('div');
      // eslint-disable-next-line no-undef
      this.captcha = _dx.Captcha(el, {
        appId: 'd1e802af9df4e5db070805fb6a4f8458',
        style: 'popup',
        language,
        success: (token) => {
          this.success(token);
          this.captcha.hide();
        },
      });
      document.body.appendChild(el);
    } catch (e) {
      console.error(e);
    }
  }

  show(success) {
    // 由于第三方资源加载失败可能导致 initCaptcha 中 captcha 对象创建失败，避免空异常
    if (this.captcha) {
      this.success = success;
      this.captcha.show();
    }
  }
}
